// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export const MAX_STATES = 50;
const CURRENT_PLACEHOLDER = {};

class HistoryManager {
  // @states is implemented as a circular buffer of size
  // MAX_STATES, with entries starting at @head, ending at
  // @tail inclusive. It must ALWAYS have at least one entry.

  // @states[@walk] is what the user is currently viewing.
  // Note: this might be a placeholder for the current
  // state. We don't care about the current state until
  // we are about to depart it, so we just mark the position
  // as being placeholder'd.

  // When we depart the current state, we might need to
  // fill in the placeholder with the current state.
  // Otherwise we can simply explore tail <= walk <= head.

  constructor() {
    this.reset();
  }

  reset() {
    this.states = [CURRENT_PLACEHOLDER];
    this.head = 0; // newest entry
    this.tail = 0; // oldest entry
    this.walk = 0; // where we are
  }

  canUndo() {
    return this.walk !== this.tail;
  }

  canRedo() {
    return this.walk !== this.head;
  }

  undo(state) {
    if (this.states[this.walk] === CURRENT_PLACEHOLDER) {
      this.states[this.walk] = state;
    }
    this.walk -= 1;
    if (this.walk < 0) {
      this.walk += MAX_STATES;
    }
    return this.states[this.walk];
  }

  redo() {
    this.walk = (this.walk + 1) % MAX_STATES;
    return this.states[this.walk];
  }

  pushState(state) {
    this.states[this.walk] = state;
    this.walk = (this.walk + 1) % MAX_STATES;
    if (this.walk === this.tail) {
      this.tail = (this.tail + 1) % MAX_STATES;
    }
    this.head = this.walk;
    this.states[this.walk] = CURRENT_PLACEHOLDER;
  }

  /**
   * Reverse the effects of `pushState(state)` if `matchFn(state)`
   */
  undoPushStateIf(matchFn) {
    // Only allow undo if we just pushed.
    if (this.head !== this.walk) {
      return false;
    }
    // Can only undo if there is something to undo to:
    if (this.head === this.tail) {
      return false;
    }
    // Peek at our "undo()".
    let prevPtr = this.walk - 1;
    if (prevPtr < 0) {
      prevPtr += MAX_STATES;
    }
    const prev = this.states[prevPtr];
    // Only do the undo if the state that we just pushed matches criteria.
    if (!matchFn(prev)) {
      return false;
    }
    // Move our pointer back and update our head.
    this.walk = prevPtr;
    this.states[this.walk] = CURRENT_PLACEHOLDER;
    this.head = this.walk;
    return true;
  }
}

export default HistoryManager;
